/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiScreeningFlow,
    InternalApiScreeningFlowFromJSON,
    InternalApiScreeningFlowToJSON,
} from '../models';

export interface CheckActiveScreeningFlowExistsRequest {
    flowId: string;
}

export interface CreateScreeningFlowRequest {
    internalApiScreeningFlow: InternalApiScreeningFlow;
}

export interface DeleteFlowRequest {
    flowId: string;
}

export interface FindScreeningFlowsRequest {
    entityType: InternalApiEntityType;
}

export interface GetScreeningFlowRequest {
    flowId: string;
}

export interface UpdateScreeningFlowRequest {
    flowId: string;
    internalApiScreeningFlow: InternalApiScreeningFlow;
}

/**
 * 
 */
export class InternalScreeningFlowsApi extends runtime.BaseAPI {

    /**
     * Checks if an active version exists for the flow
     */
    async checkActiveScreeningFlowExistsRaw(requestParameters: CheckActiveScreeningFlowExistsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling checkActiveScreeningFlowExists.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}/exists`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Checks if an active version exists for the flow
     */
    async checkActiveScreeningFlowExists(requestParameters: CheckActiveScreeningFlowExistsRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.checkActiveScreeningFlowExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates screening flow
     */
    async createScreeningFlowRaw(requestParameters: CreateScreeningFlowRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlow>> {
        if (requestParameters.internalApiScreeningFlow === null || requestParameters.internalApiScreeningFlow === undefined) {
            throw new runtime.RequiredError('internalApiScreeningFlow','Required parameter requestParameters.internalApiScreeningFlow was null or undefined when calling createScreeningFlow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningFlowToJSON(requestParameters.internalApiScreeningFlow),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowFromJSON(jsonValue));
    }

    /**
     * Creates screening flow
     */
    async createScreeningFlow(requestParameters: CreateScreeningFlowRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlow> {
        const response = await this.createScreeningFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the flow
     */
    async deleteFlowRaw(requestParameters: DeleteFlowRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling deleteFlow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the flow
     */
    async deleteFlow(requestParameters: DeleteFlowRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteFlowRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches screening flows for entity type
     */
    async findScreeningFlowsRaw(requestParameters: FindScreeningFlowsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningFlow>>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling findScreeningFlows.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningFlowFromJSON));
    }

    /**
     * Fetches screening flows for entity type
     */
    async findScreeningFlows(requestParameters: FindScreeningFlowsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningFlow>> {
        const response = await this.findScreeningFlowsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches a screening flow by id
     */
    async getScreeningFlowRaw(requestParameters: GetScreeningFlowRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlow>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling getScreeningFlow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowFromJSON(jsonValue));
    }

    /**
     * Fetches a screening flow by id
     */
    async getScreeningFlow(requestParameters: GetScreeningFlowRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlow> {
        const response = await this.getScreeningFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates screening flow
     */
    async updateScreeningFlowRaw(requestParameters: UpdateScreeningFlowRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningFlow>> {
        if (requestParameters.flowId === null || requestParameters.flowId === undefined) {
            throw new runtime.RequiredError('flowId','Required parameter requestParameters.flowId was null or undefined when calling updateScreeningFlow.');
        }

        if (requestParameters.internalApiScreeningFlow === null || requestParameters.internalApiScreeningFlow === undefined) {
            throw new runtime.RequiredError('internalApiScreeningFlow','Required parameter requestParameters.internalApiScreeningFlow was null or undefined when calling updateScreeningFlow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening/configurations/flows/{flowId}`.replace(`{${"flowId"}}`, encodeURIComponent(String(requestParameters.flowId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningFlowToJSON(requestParameters.internalApiScreeningFlow),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningFlowFromJSON(jsonValue));
    }

    /**
     * Updates screening flow
     */
    async updateScreeningFlow(requestParameters: UpdateScreeningFlowRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningFlow> {
        const response = await this.updateScreeningFlowRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
